import React from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';

// TYPES
import { TitleFull as Title } from '@warehouse/title/core';

// LIBRARIES
import CountriesOfOriginField from '../fields/CountriesOfOrigin';
import ReleaseDate from '../fields/ReleaseDate';
import OriginalLanguagesField from '../fields/OriginalLanguages';
import RunLengthField from '../fields/RunLength';
import SortTitleField from '../fields/SortTitle';

// STYLES
import { Row } from './styles';

interface SeriesProps {
	control: Control<any>;
	setValue: UseFormSetValue<any>;
	trigger: UseFormTrigger<any>;
	errors: FieldErrors<any>;
	dryRanTitle?: Title | undefined;
}

function Series({ control, errors, setValue, trigger, dryRanTitle }: SeriesProps) {
	return (
		<div>
			<Row>
				<CountriesOfOriginField
					control={control}
					setValue={setValue}
					trigger={trigger}
					errors={errors}
					isRequired
					dryRanTitle={dryRanTitle}
				/>
				<ReleaseDate
					control={control}
					isRequired
					setValue={setValue}
					trigger={trigger}
					errors={errors}
					dryRanTitle={dryRanTitle}
				/>
			</Row>
			<Row>
				<SortTitleField
					control={control}
					setValue={setValue}
					trigger={trigger}
					errors={errors}
					dryRanTitle={dryRanTitle}
				/>
				<RunLengthField
					control={control}
					setValue={setValue}
					trigger={trigger}
					dryRanTitle={dryRanTitle}
					errors={errors}
				/>
			</Row>
			<OriginalLanguagesField
				control={control}
				setValue={setValue}
				trigger={trigger}
				errors={errors}
				isRequired
				dryRanTitle={dryRanTitle}
			/>
		</div>
	);
}

export default Series;
